module.exports = "/davinci/assets/b09e44c2ca19f4ed5178a795c5e1dcdb.svg";